<app-view-item *ngIf="disabled" [text]="getLabel(selected)"></app-view-item>

<nz-select *ngIf="!disabled"
  nzShowSearch
  nzServerSearch
  [nzFilterOption]="nzFilterOption"
  (nzOnSearch)="search($event)"
  (nzOpenChange)="search('')"
  [nzCustomTemplate]="displayTpl"
  [nzDropdownRender]="renderTemplate"
  [(ngModel)]="value"
  (ngModelChange)="valueChanged($event)"
  [nzDropdownMatchSelectWidth]="false"
  [nzBorderless]="borderless"
  [nzAllowClear]="allowClear"
  [nzBackdrop]="addBackdrop"
  class="width-100">

  <ng-template #displayTpl let-selected>
    {{ selected.nzLabel }}
  </ng-template>
  <ng-container *ngFor="let o of list">
    <nz-option *ngIf="!searching" [nzValue]="getValue(o)" [nzLabel]="getLabel(o)" nzCustomContent>
      <div>
        <strong>{{ o.code }}</strong>
        :
        <span> {{ o.name }}</span>
      </div>
    </nz-option>
  </ng-container>
</nz-select>
<ng-template #renderTemplate>
  <nz-spin *ngIf="loading"></nz-spin>
  <nz-divider class="m-none"></nz-divider>
</ng-template>
